import { createApp } from 'vue';
import App from './App.vue';
import { createI18n } from 'vue-i18n';
import { VueReCaptcha } from 'vue-recaptcha-v3'

const messages = {
  en: require('./locales/en.json'),
  pt: require('./locales/pt.json'),
};

const i18n = createI18n({
  legacy: false,
  locale: navigator.language.startsWith('pt') ? 'pt' : 'en',
  messages,
});

createApp(App).use(VueReCaptcha, {
  siteKey: '6LcWomssAAAAACp7DwLeiExvjZciCV_-vCmrN6kI'
}).use(i18n).mount('#app');